import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import TransferCustomer from "modules/transfer_customer/TransferCustomer";
import RecentTransfer from "./RecentTransfer";
import TransferCustomerUpload from "./TransferCustomerUpload";

function AdminCaseManagement() {
  const [activeTab, setActiveTab] = useState("transfer_customer");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const tab = searchParams.get("tab");
    setActiveTab(tab);
  }, []);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    navigate(`/admin-case-management?tab=${tabKey}`);
  };

  return (
    <div>
      <Tabs
        variant="pills"
        defaultActiveKey="transfer_customer"
        id="uncontrolled-tab-example"
        activeKey={activeTab}
        onSelect={handleTabChange}
        className="pb-2 border-bottom border-2 "
      >
        <Tab
          eventKey="transfer_customer"
          title="Transfer Customer"
          className="mb-3"
        >
          <TransferCustomer />
        </Tab>
        <Tab
          eventKey="recent_transfer"
          title="Recent Transfer"
          className="mt-2"
        >
          <RecentTransfer />
        </Tab>

        <Tab
          eventKey="transfer_customer_upload"
          title="Transfer Customers Upload"
          className="mt-2"
        >
          <TransferCustomerUpload />
        </Tab>
      </Tabs>
    </div>
  );
}

export default AdminCaseManagement;
